export default {"src":"/_next/static/media/man_with_tie_40.0a070546.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};